import SearchAPI from '../../api/search';

const types = {
  SET: 'INTERNAL_CHAT_SEARCH_SET',
  SET_UI_FLAG: 'INTERNAL_CHAT_SEARCH_SET_UI_FLAG',
};

export const initialState = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getRecords(state) {
    return state.records;
  },
  getUIFlags(state) {
    return state.uiFlags;
  },
};

export const actions = {
  async search({ commit }, q) {
    commit(types.SET, []);
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const { data } = await SearchAPI.internalMessages(q);
      commit(types.SET, data.payload.internal_messages);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },
  clearSearchResults({ commit }) {
    commit(types.SET, []);
  },
};

export const mutations = {
  [types.SET](state, records) {
    state.records = records;
  },
  [types.SET_UI_FLAG](state, uiFlags) {
    state.uiFlags = { ...state.uiFlags, ...uiFlags };
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
